document.addEventListener('DOMContentLoaded', () => {
  // Product ID to restrict quantity
  const RESTRICTED_PRODUCT_ID = '8514031747306';
  const MAX_QUANTITY = 1;
  const PRODUCT_NAME = "VIP Membership"; // Add product name for clearer error messages

  // Function to check if cart contains restricted product
  async function checkCartForRestrictedProduct() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Check if cart contains the restricted product
      const restrictedItem = cart.items.find(item => 
        item.product_id.toString() === RESTRICTED_PRODUCT_ID);
      
      if (restrictedItem && restrictedItem.quantity > MAX_QUANTITY) {
        // Update quantity to maximum allowed
        await updateCartItemQuantity(restrictedItem.key, MAX_QUANTITY);
        
        // Show error message
        showErrorMessage(`${PRODUCT_NAME} is limited to ${MAX_QUANTITY} per order.`);
      }
    } catch (error) {
      console.error('Error checking cart:', error);
    }
  }

  // Function to show error message
  function showErrorMessage(message) {
    // Check if an error message element already exists
    let errorElement = document.getElementById('quantity-limit-error');
    
    if (!errorElement) {
      // Create error message element if it doesn't exist
      errorElement = document.createElement('div');
      errorElement.id = 'quantity-limit-error';
      errorElement.style.cssText = 'position: fixed; top: 20px; right: 20px; background-color: #f8d7da; color: #721c24; padding: 12px 20px; border-radius: 4px; box-shadow: 0 2px 5px rgba(0,0,0,0.2); z-index: 10000; max-width: 300px; font-weight: bold;';
      document.body.appendChild(errorElement);
    }
    
    // Set the message
    errorElement.textContent = message;
    
    // Show the message and set a timeout to hide it
    errorElement.style.display = 'block';
    setTimeout(() => {
      errorElement.style.display = 'none';
    }, 5000);
  }

  // Function to update cart item quantity
  async function updateCartItemQuantity(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      });
      
      // Refresh the page to show updated cart
      window.location.reload();
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  // Function to modify add to cart behavior
  function modifyAddToCartButtons() {
    // Override the add to cart form submission
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      const productIdInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');
      
      if (!productIdInput) return;
      
      // Get the product ID from the form
      const productId = form.dataset.productId || 
                        form.querySelector('[data-product-id]')?.dataset.productId;
      
      // If this is our restricted product
      if (productId === RESTRICTED_PRODUCT_ID) {
        // Set max quantity attribute
        if (quantityInput) {
          quantityInput.setAttribute('max', MAX_QUANTITY);
          quantityInput.setAttribute('data-max', MAX_QUANTITY);
          
          // Catch the input event before the change event fires
          quantityInput.addEventListener('input', (e) => {
            if (parseInt(e.target.value) > MAX_QUANTITY) {
              e.preventDefault();
              e.target.value = MAX_QUANTITY;
              showErrorMessage(`${PRODUCT_NAME} is limited to ${MAX_QUANTITY} per order.`);
            }
          });
          
          // Ensure quantity doesn't exceed max on change event
          quantityInput.addEventListener('change', (e) => {
            if (parseInt(e.target.value) > MAX_QUANTITY) {
              e.preventDefault();
              e.target.value = MAX_QUANTITY;
              showErrorMessage(`${PRODUCT_NAME} is limited to ${MAX_QUANTITY} per order.`);
            }
          });
          
          // Use blur event to catch when focus leaves the input
          quantityInput.addEventListener('blur', (e) => {
            if (parseInt(e.target.value) > MAX_QUANTITY) {
              e.target.value = MAX_QUANTITY;
              showErrorMessage(`${PRODUCT_NAME} is limited to ${MAX_QUANTITY} per order.`);
            }
          });
        }
        
        // Add submit event listener
        form.addEventListener('submit', async (e) => {
          // Check if cart already contains the restricted product
          const response = await fetch('/cart.js');
          const cart = await response.json();
          
          const existingItem = cart.items.find(item => 
            item.product_id.toString() === RESTRICTED_PRODUCT_ID);
          
          if (existingItem) {
            e.preventDefault();
            showErrorMessage(`You can only purchase 1 ${PRODUCT_NAME}. You already have it in your cart.`);
            return false;
          }
          
          // Ensure quantity is limited to max
          if (quantityInput && parseInt(quantityInput.value) > MAX_QUANTITY) {
            e.preventDefault();
            quantityInput.value = MAX_QUANTITY;
            showErrorMessage(`${PRODUCT_NAME} is limited to ${MAX_QUANTITY} per order.`);
            return false;
          }
        });
      }
    });
  }

  // Function to attach quantity controls to cart items
  function modifyCartQuantityControls() {
    document.querySelectorAll('.cart-item').forEach(cartItem => {
      const productInfo = cartItem.querySelector('[data-product-id]');
      if (!productInfo || productInfo.dataset.productId !== RESTRICTED_PRODUCT_ID) return;
      
      const quantityInput = cartItem.querySelector('input[name="updates[]"]');
      if (!quantityInput) return;
      
      // Catch the input event before the change event fires
      quantityInput.addEventListener('input', (e) => {
        if (parseInt(e.target.value) > MAX_QUANTITY) {
          e.target.value = MAX_QUANTITY;
          showErrorMessage(`${PRODUCT_NAME} is limited to ${MAX_QUANTITY} per order.`);
          // Prevent the cart update from happening
          e.stopPropagation();
        }
      });
      
      // Monitor cart quantity changes
      quantityInput.addEventListener('change', (e) => {
        if (parseInt(e.target.value) > MAX_QUANTITY) {
          e.preventDefault(); // Prevent the default behavior
          e.target.value = MAX_QUANTITY;
          showErrorMessage(`${PRODUCT_NAME} is limited to ${MAX_QUANTITY} per order.`);
          // Stop event propagation to prevent cart update
          e.stopPropagation();
        }
      });
      
      // Use blur event for when focus leaves the input
      quantityInput.addEventListener('blur', (e) => {
        if (parseInt(e.target.value) > MAX_QUANTITY) {
          e.target.value = MAX_QUANTITY;
          showErrorMessage(`${PRODUCT_NAME} is limited to ${MAX_QUANTITY} per order.`);
        }
      });
      
      // Disable the plus button when at max
      const plusButton = cartItem.querySelector('.quantity__button[name="plus"]');
      if (plusButton) {
        plusButton.addEventListener('click', (event) => {
          if (parseInt(quantityInput.value) >= MAX_QUANTITY) {
            event.preventDefault();
            event.stopPropagation();
            showErrorMessage(`${PRODUCT_NAME} is limited to ${MAX_QUANTITY} per order.`);
          }
        });
      }
    });
  }

  // Watch for cart-drawer events
  document.addEventListener('cart:refresh', checkCartForRestrictedProduct);
  document.addEventListener('cart:added', checkCartForRestrictedProduct);
  
  // Run on page load
  checkCartForRestrictedProduct();
  modifyAddToCartButtons();
  modifyCartQuantityControls();
  
  // Add a mutation observer to catch dynamically added elements
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        modifyAddToCartButtons();
        modifyCartQuantityControls();
      }
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
}); 